import downloadPriloha from '../client/prilohaVestnikaDownloadClient';

export const handleDownloadPriloha = async (
  prilohaUuid: string,
  filename: string,
  options?: { headers?: object },
): Promise<void> => {
  const { data } = await downloadPriloha(prilohaUuid, options);

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      filename,
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
